export const FETCH_REMOTE_CONFIG_REQUEST = "FETCH_REMOTE_CONFIG_REQUEST";
export const FETCH_REMOTE_CONFIG_SUCCESS = "FETCH_REMOTE_CONFIG_SUCCESS";
export const FETCH_REMOTE_CONFIG_FAILURE = "FETCH_REMOTE_CONFIG_FAILURE";
